<template>
	<div class="help_center">
		<div v-wechat-title="$route.meta.title"></div>
		<TopBar></TopBar>
		<div style="display: flex;justify-content: center; margin-top: 0px;">
			<div style="height: 900px; width: 240px; background-color: #FFFFFF;">
				<Menu mode="vertical" :active-name="defaultMenus" ref="allMenus" @on-select="getQuestionUnderCategory" >
                    <MenuItem v-for="(category,index) in helperCategoryList" :key="index" :name="category.value">
						<span>{{category.name}}</span>
						<Icon  v-if="userInfo.menuList.homePage.helpCenter_removeHelpCenter" @click.stop="deleteCategory" :data-id="category.value" type="md-close" class="delete_icon"/>

					</MenuItem>
				</Menu>
			</div>
			<div style="width: 1350px; min-height: 500px; background-color: #FFFFFF;margin-left: 20px; padding: 20px;">
				<div style="width: 400px" class="yl-flex flex_between">
					<Input placeholder="请输入标题内容..." v-model="searchTitle" style="width: 300px">
					<i-button slot="append" icon="ios-search"></i-button>
					</Input>
                    <input type="hidden"  v-model="currentCategoryId">
					<Button class='ivu-btn-circle' type="primary" @click="" style="margin-left: 10px;">搜索</Button>
                    <Button v-if="userInfo.menuList.homePage.helpCenter_editHelpCenter" class='ivu-btn-circle' type="primary" @click="addNewCategory" style="margin-left: 20px;">新增分类</Button>
					<Button v-if="userInfo.menuList.homePage.helpCenter_editHelpCenter" class='ivu-btn-circle' type="primary" @click="addNewFaq" style="margin-left: 20px;">新增问题</Button>
                    <!-- <Button class='ivu-btn-circle' type="warning" @click="EditNewCategory" style="margin-left: 20px;">管理</Button> -->
				</div>
				<div style="margin-top: 20px;" v-for="(question,index) in  questionUnderCategory" :key="index">
					<div class="message_list">
						<span style="color: #277dd3;" class="icon iconfont icon-yuandianxiao"></span>
						<span class="message_list_text" style="cursor: pointer;" @click="detailsClick" :data-index="index">{{question.questionTitle}}</span>
						<Icon  v-if="userInfo.menuList.homePage.helpCenter_removeHelpCenter" @click.stop="deleteFaq" :data-id="question.id" type="md-close" class="delete_icon" />
					</div>
                   
				</div>
                
			</div>
		</div>
		
		<!-- 添加问题弹出层 -->
		<Modal footer-hide v-model="addFaqShow" title="添加问题" width="800" height="900">
            <div style="margin-top: 10px;">
                <span style="width: 100px;display: inline-block;">类别 </span>
                <Select v-model="category" style="width: 200px;">
                    <Option v-for="(category, index) in helperCategoryList" :key="index" :value="category.value">{{category.name}}</Option>
                </Select>
            </div>
            <div style="margin-top: 10px;">
                <span style="width: 100px;display: inline-block;">标题</span>
                <Input v-model="descriptionTitle" type="text" style="width: 200px;"/>
            </div>
            <div style="margin-top: 10px;">
                <span >问题描述: </span>
                <Input v-model="descriptionContent" type="textarea" style="margin-top: 10px;"></Input>
            </div>
            <!-- <Button type="error" style="margin-top: 20px;">删除</Button> -->
            <Button type="primary" @click="addHelperCategoryDescription" style="margin-top: 20px;">确定</Button>
		</Modal>
		<!-- 问题详情对话框 -->
		<Modal footer-hide v-model="detailsShow" :title="questionTitle" width="700">
			{{questionContent}}
		</Modal>
		<!-- 添加分类弹出层 -->
		<Modal footer-hide v-model="addCategoryShow" title="添加分类" width="500">
			<div>
				<span style="width: 100px;display: inline-block;">分类</span>
				<Input v-model="newCategoryName" type="text" style="width: 200px;"/>
			</div>
			<Button type="primary" @click="addHelperCategory" style="margin-top: 20px;">确定</Button>
		</Modal>
	</div>
</template>

<script>
	import TopBar from '../topbar/TopBar.vue';
    import {mapGetters} from 'vuex';
    import {
        addHelperCategory,getAllHelperCategory,addHelperCategoryDescription,getQuestionByCategory,deleteFaqCategory,deleteFaq
    } from '@/api/helpcenter.js';
	import {countDownClient} from "../../api/finance";

	export default {
		name: "HelpCenter",
		components: {
			TopBar,
		},
		computed:{
            ...mapGetters(['userInfo', 'token']),
		},

		data() {
			return {
                defaultMenus:'',
				detailsShow: false,
				addCategoryShow: false,
                addFaqShow:false,
				questionTitle:'',
				questionContent:'',
                currentCategoryId:'',
                searchTitle:'',
                newCategoryName:'',
                descriptionTitle:'',
                descriptionContent:'',
                categoryTitle:'',
                category:'',
                //分类下的问题
                questionUnderCategory:[],
                
                //常见问题分类
                faqCategory:[],
                
                
                helperCategoryList:[],
                categoryDescription:''

			}
		},
        created(){
            this.getAllHelperCategory();
        },
        
		methods: {
			// getQuestionList() {
   //              let that = this
   //              let data = {token:that.token, categoryId:that.currentCategoryId, searchParam:that.searchTitle}
   //              //获取搜索的数据
   //              getQuestionByCategory(data).then( function(res){
   //                  that.questionUnderCategory = res.data.data
   //              });
			// },
			// 点击title显示详情
			detailsClick(e) {
                //获取数据列
                let index  = e.currentTarget.dataset.index;
                //获取数据列的title和content
                this.questionTitle = this.questionUnderCategory[index]['questionTitle'];
                this.questionContent = this.questionUnderCategory[index]['questionContent'];
                //显示遮罩层
                this.detailsShow = true
			},
            addNewCategory(){
                this.addCategoryShow = true;
            },
			addNewFaq(){
				this.addFaqShow = true;
			},
            //获取分类列表
            getAllHelperCategory(){
                let that = this
                let data = {};
                data.token = that.token;
                getAllHelperCategory(data).then(res=>{
                    if(res.data.code == 1){
                        that.helperCategoryList = res.data.data
						that.currentCategoryId = that.helperCategoryList[0].value
						that.getQuestionUnderCategory(that.helperCategoryList[0].value)
                    }
                });
            },
            //添加问题分类
            addHelperCategory(){
                let that = this
                let data = {}
                data.token = that.token;
                data.categoryName = that.newCategoryName;
                addHelperCategory(data).then(res=>{
                   if(res.data.code == 1){
                       that.$Message.success(res.data.msg)
                       //更新分类列表
                       that.getAllHelperCategory();
                       //清空输入框
                       that.newCategoryName = '';
					   that.addCategoryShow = false;
                   }else{
                       that.$Message.error(res.data.msg);
                   }
                })
            },
            //添加问题内容
            addHelperCategoryDescription(){
                let that = this
                let data = {};
                data.token = that.token;
                data.categoryId = that.category;
                data.descriptionTitle = that.descriptionTitle;
                data.descriptionContent = that.descriptionContent;
                addHelperCategoryDescription(data).then(res=>{
                    if (res.data.code == 1) {
                    	that.$Message.success(res.data.msg);
                    	that.getQuestionUnderCategory(that.currentCategoryId);
                    	that.addFaqShow = false;
					}
                })
            },
            // getHelperCategory(){
            //     let that = this
            //     let data = {token:that.token};
            //     getFAQCategory(data).then( function(res){
            //         that.faqCategory = res.data.data

            //         //获取数组中第一个元数据的categoryId作为默认menus
            //         that.defaultMenus = that.faqCategory[0]['categoryId']
            //         that.getQuestionUnderCategory(that.defaultMenus)
            //         //获取数据之后手动更新Menus组件
            //         that.$nextTick(() => {
            //             that.$refs.allMenus.updateOpened()
            //             that.$refs.allMenus.updateActiveName() 
            //         });
            //     });
            // },
            getQuestionUnderCategory(categoryId){
                let that = this
                that.currentCategoryId = categoryId;
                let data = {token:that.token, categoryId:categoryId}
                //切换Menus时清空search输入框
                that.searchTitle = '';
                //获取分类下的所有问题
                getQuestionByCategory(data).then( function(res){
                    that.questionUnderCategory = res.data.data
                });
            },
			deleteCategory(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
							let data = {token: that.token, id:id}
							let res = await deleteFaqCategory(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
							}
							that.getAllHelperCategory();
						}, 500)
					}
				})
			},
			deleteFaq(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				that.$Modal.confirm({
					title: '确认删除吗？',
					onOk: async() => {
						that.throttle(async function () {
							let data = {token: that.token, id:id}
							let res = await deleteFaq(that, data);
							if (res.code == 1) {
								that.$Message.success(res.msg);
							}
							that.getQuestionUnderCategory(that.currentCategoryId);
						}, 500)
					}
				})
			}
           
		}
	}
</script>

<style scoped lang="less">
	.help_center {
		min-width: 1900px;
		height: 100%;
		background-color: #F8F9FB;
	}

	.yl-flex {
		display: flex;
		justify-content: space-between;
	}

	.message_list {
		position: relative;
		border-top: 1px solid #F1F1F1;
		height: 40px;
		line-height: 40px;
		display: flex;
		align-items: center;
	}

	.message_list_text:hover {
		color: #277dd3;
	}

	.delete_icon{
		position:absolute; top:40%; right: 5%;
	}
</style>
